import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class RegenerateEbookUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(invitationCode: string): Promise<Blob | undefined>{
        return this.tripbooksRepository.regenerateEbook(invitationCode);
    }
}
